import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactComponent as LogoIcon } from '../../icons/LogoGroup.svg';

const useStyles = makeStyles(theme => ({
  drawerHeader: {
    height: 65,
    padding: theme.spacing(3, 2),
    justifyContent: 'center',
  },
  drawerHeaderIcon: {
    height: 36,
    width: 36,
  },
  drawerIconRight: {
    position: 'absolute',
    right: theme.spacing(2),
  },
  drawerIconCenter: {
    alignItems: 'center',
  },
  logoIcon: {
    height: 36,
    position: 'absolute',
    left: theme.spacing(2),
  },
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

interface SidebarHeaderProps {
  open: boolean;
  collapsible: boolean;
  sidebarToggle: () => void;
}

const SidebarHeader = ({ open, collapsible, sidebarToggle } : SidebarHeaderProps) => {
  const classes = useStyles();

  const onClick = () => {
    if (collapsible) {
      sidebarToggle();
    }
  };

  return (
    <DrawerHeader className={classes.drawerHeader}>
      {open && <LogoIcon className={classes.logoIcon} />}
      <IconButton
        onClick={onClick}
        className={clsx(classes.drawerHeaderIcon, {
          [classes.drawerIconRight]: open,
          [classes.drawerIconCenter]: !open,
        })}
      >
        {collapsible && open ? <ChevronLeftIcon /> : <MenuIcon />}
      </IconButton>
    </DrawerHeader>
  );
};

export default SidebarHeader;
